import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ProgressTypeEnum } from '../../enums/progress-type/progress-type.enum';
import { Progress } from './progress.model';

export const httpEventToProgress = <Body>(
    event: HttpEvent<Body>,
): Progress<Body> => {
    switch (event.type) {
        case HttpEventType.UploadProgress:
            return {
                type: ProgressTypeEnum.PENDING,
                percent: event.total
                    ? Math.round((100 * event.loaded) / event.total)
                    : 0,
            };
        case HttpEventType.Response:
            return {
                type: ProgressTypeEnum.DONE,
                data: event.body as Body,
            };
        default:
            return {
                type: ProgressTypeEnum.PENDING,
                percent: undefined,
            };
    }
};
